import { api } from './api';

// Define the profile stats response interface
export interface ProfileStatsResponse {
  totalCourses: number;
  totalCompleted: number;
  totalLessonsCompleted: number;
}

// Define the dashboard stats response interface
export interface DashboardStatsResponse {
  totalUsers: number;
  totalOrganizations: number;
  totalCourses: number;
  totalCompleted: number;
  totalLessonsCompleted: number;
}

/**
 * Fetch profile stats for regular users
 */
export const fetchProfileStats = async (): Promise<ProfileStatsResponse> => {
  try {
    const response = await api.get<ProfileStatsResponse>('/api/Stats/ProfileStats');
    return response.data;
  } catch (error) {
    console.error('Error fetching profile stats:', error);
    // Return default values if API call fails
    return {
      totalCourses: 0,
      totalCompleted: 0,
      totalLessonsCompleted: 0
    };
  }
};

/**
 * Fetch dashboard stats for admin dashboard
 */
export const fetchDashboardStats = async (): Promise<DashboardStatsResponse> => {
  try {
    const response = await api.get<DashboardStatsResponse>('/api/Stats/DashboardStats');
    return response.data;
  } catch (error) {
    console.error('Error fetching dashboard stats:', error);
    // Return default values if API call fails
    return {
      totalUsers: 0,
      totalOrganizations: 0,
      totalCourses: 0,
      totalCompleted: 0,
      totalLessonsCompleted: 0
    };
  }
}; 